import React, { useState } from 'react';
import { Modal, Button, Form } from '@themesberg/react-bootstrap';

const DynamicModal = ({
  show,
  handleClose,
  onCancel,
  onSuccess,
  setConfirmationModalProps,
  fields = [],
}) => {
  const [formData, setFormData] = useState(
    fields.reduce((acc, field) => {
      acc[field.key] = '';
      return acc;
    }, {})
  );

  const [errors, setErrors] = useState({});

  const handleChange = (key, value) => {
    // Update form data
    setFormData((prev) => ({ ...prev, [key]: value }));
    // Update confirmation modal props
    setConfirmationModalProps((prev) => {
        return {
            ...prev, [key] : value
        }
    });
  };

  const validateFields = () => {
    const newErrors = {};
    fields.forEach((field) => {
      if (field.required && !formData[field.key]) {
        newErrors[field.key] = `*${field.label} is required`;
      } else if (field.validation && !field.validation(formData[field.key])) {
        newErrors[field.key] = `*Invalid ${field.label}`;
      }
    });
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSaveAndProceed = () => {
    if (validateFields()) {
      onSuccess();
    }
  };

  return (
    <Modal
      size="lg"
      show={show}
      onHide={handleClose}
      centered
      style={{ textAlign: 'center' }}
    >
      <Modal.Body
        style={{
          padding: '30px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <h5
          style={{
            fontWeight: '600',
            fontSize: '22px',
            color: '#333',
            marginBottom: '10px',
          }}
        >
          Enter Details
        </h5>
        <p
          style={{
            fontSize: '14px',
            color: '#555',
            marginBottom: '20px',
          }}
        >
          Please fill in the required details to proceed.
        </p>

        {fields.map((field) => (
          <Form.Group
            key={field.key}
            style={{
              marginBottom: '20px',
              width: '100%',
              maxWidth: '400px',
            }}
          >
            <Form.Control
              type={field.type || 'text'}
              placeholder={field.placeholder || `Enter ${field.label}`}
              value={formData[field.key] || ''}
              onChange={(e) => handleChange(field.key, e.target.value)}
              style={{
                fontSize: '14px',
                padding: '10px',
                borderColor: errors[field.key] ? 'red' : '#ccc',
                borderRadius: '4px',
              }}
            />
            {errors[field.key] && (
              <small
                style={{
                  color: 'red',
                  display: 'block',
                  textAlign: 'left',
                  marginTop: '5px',
                }}
              >
                {errors[field.key]}
              </small>
            )}
          </Form.Group>
        ))}

        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            marginTop: '30px',
            width: '80%',
            maxWidth: '400px',
          }}
        >
          <Button
            variant="light"
            className="text-gray"
            style={{
              padding: '10px 0',
              width: '30%',
              fontSize: '14px',
              fontWeight: '500',
              backgroundColor: '#F0F0F0',
              borderRadius: '4px',
            }}
            onClick={onCancel}
          >
            Cancel
          </Button>
          <Button
            variant="dark"
            style={{
              padding: '10px 0',
              width: '30%',
              fontSize: '14px',
              fontWeight: '500',
              color: '#fff',
              backgroundColor: '#444444',
              borderRadius: '4px',
            }}
            onClick={handleSaveAndProceed}
          >
            Save and Proceed
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default DynamicModal;
